/**
 * @generated SignedSource<<35525110091e6d0efd77237de72f9d41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpSidebar_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HeartPill_viewer" | "NftHeartPillProvider_viewer" | "NftPdpLiveDetailsRefetchWrapper_viewer">;
  readonly " $fragmentType": "NftPdpSidebar_viewer";
};
export type NftPdpSidebar_viewer$key = {
  readonly " $data"?: NftPdpSidebar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpSidebar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "nftId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpSidebar_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeartPill_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchUser",
          "variableName": "fetchUser"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "nftIds.0",
              "variableName": "nftId"
            }
          ],
          "kind": "ListValue",
          "name": "nftIds"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "NftHeartPillProvider_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpLiveDetailsRefetchWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6f862c72e2243584a3cbabc9577b685b";

export default node;
